import type { Role } from "./types";

/**
 * Where each role lands after signing in, and where a route they cannot reach
 * sends them back to. One definition, because a marketer dropped on the licence
 * list would be redirected straight back out of it — which reads as the sign-in
 * having failed.
 */
const HOME: Record<Role, string> = {
  admin: "/dashboard",
  customer: "/orders",
  marketer: "/commission",
};

export function homeFor(role: Role | string): string {
  return HOME[role as Role] ?? "/orders";
}
